(() => {
  const initializedModalAttribute = 'data-teams-video-modal-initialized';
  const initializedOpenerAttribute = 'data-teams-video-opener-initialized';
  const initializedPreviewAttribute = 'data-teams-video-preview-initialized';
  const openModalAttribute = 'open';

  const getFocusableElements = (container) => {
    if (!container) {
      return [];
    }

    return Array.from(
      container.querySelectorAll(
        'a[href], area[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])'
      )
    ).filter((element) => element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement);
  };

  const loadVideo = (modal) => {
    const media = modal.querySelector('.teams-video-modal__video');

    if (!media || media.querySelector('iframe')) {
      return;
    }

    const template = media.querySelector('template');

    if (template) {
      media.appendChild(template.content.cloneNode(true));
    }
  };

  const unloadVideo = (modal) => {
    const media = modal.querySelector('.teams-video-modal__video');

    if (!media) {
      return;
    }

    Array.from(media.children).forEach((child) => {
      if (child.tagName !== 'TEMPLATE') {
        child.remove();
      }
    });
  };

  const closeModal = (modal) => {
    if (!modal || !modal.hasAttribute(openModalAttribute)) {
      return;
    }

    modal.removeAttribute(openModalAttribute);
    unloadVideo(modal);

    if (modal.previousActiveElement && typeof modal.previousActiveElement.focus === 'function') {
      modal.previousActiveElement.focus({ preventScroll: true });
    }
  };

  const openModal = (modal, trigger) => {
    if (!modal) {
      return;
    }

    modal.previousActiveElement = trigger || document.activeElement;
    modal.setAttribute(openModalAttribute, '');
    loadVideo(modal);

    const focusTarget = modal.querySelector('.teams-video-modal__close') || modal.querySelector('.teams-video-modal__content') || modal;
    focusTarget.focus({ preventScroll: true });
  };

  const handleKeydown = (event, modal) => {
    if (!modal.hasAttribute(openModalAttribute)) {
      return;
    }

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal(modal);
      return;
    }

    if (event.key !== 'Tab') {
      return;
    }

    const focusableElements = getFocusableElements(modal);

    if (!focusableElements.length) {
      event.preventDefault();
      return;
    }

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  };

  const initializeModal = (modal) => {
    if (modal.hasAttribute(initializedModalAttribute)) {
      return;
    }

    modal.setAttribute(initializedModalAttribute, 'true');

    modal.addEventListener('click', (event) => {
      if (event.target === modal || event.target.closest('.teams-video-modal__close')) {
        event.preventDefault();
        closeModal(modal);
      }
    });

    modal.addEventListener('keydown', (event) => handleKeydown(event, modal));
  };

  const initializeOpeners = (root) => {
    root.querySelectorAll('modal-opener[data-modal]').forEach((opener) => {
      if (opener.hasAttribute(initializedOpenerAttribute)) {
        return;
      }

      const modalSelector = opener.getAttribute('data-modal');
      const modal = modalSelector ? document.querySelector(modalSelector) : null;

      if (!modal) {
        return;
      }

      opener.setAttribute(initializedOpenerAttribute, 'true');
      initializeModal(modal);

      opener.addEventListener('click', (event) => {
        event.preventDefault();
        openModal(modal, opener.querySelector('button, a') || opener);
      });
    });
  };

  const initializePreviews = (root) => {
    root.querySelectorAll('[data-teams-hero-preview-video]').forEach((video) => {
      if (video.hasAttribute(initializedPreviewAttribute)) {
        return;
      }

      video.setAttribute(initializedPreviewAttribute, 'true');
      video.defaultMuted = true;
      video.muted = true;
      video.playsInline = true;

      const playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    });
  };

  const initialize = (root = document) => {
    root.querySelectorAll('.teams-video-modal').forEach(initializeModal);
    initializeOpeners(root);
    initializePreviews(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
